import { render, staticRenderFns } from "./FormAmend.vue?vue&type=template&id=58aa257c"
import script from "./FormAmend.vue?vue&type=script&lang=js"
export * from "./FormAmend.vue?vue&type=script&lang=js"
import style0 from "./FormAmend.vue?vue&type=style&index=0&id=58aa257c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports